import diseases from '../../repo/diseases';
import KeyCode from '../../util/keycode';
import EditableSymptom from './editable-symptom';
import template from './edit.tpl';
import router from './../../navigation/router';
import './edit.css';

const AddDiseaseForm = DomClass(template, function AddDiseaseForm() {
	const _t = this;

	this.symptoms = this.symptoms || [];
	this.name = this.name || '';
	this._lastLoadedNormalizedName = '';

	// TODO: instead of putting this into readonly mode while loading the
	// existing disease data, just check to see whether the user has entered
	// any disease data before writing over it -- if they have, prompt them
	// for what to do.
	let _isReadonly = false;
	Object.defineProperty(this, 'isReadonly', {
		set: function(readonly) {
			_isReadonly = readonly;
			for (var i = 0; i < this.form.elements.length; i++) {
				try {
					// this.form.elements[i].disabled = _isReadonly;
				} catch {
					// don't even worry about it.
				}
			};
		},
		get: function() {
			 return _isReadonly
		},
		enumerable: true
	});

	// maybe this should be a property of `Disease` and this class should
	// actually construct a `Disease` and use it's `normalizedName` property.
	Object.defineProperty(this, 'normalizedName', {
		get: function() {
			return this.name.toLowerCase();
		},
		enumerable: true,
	});

	this.load = async function() {
		if (!this.normalizedName) return;
		if (this.normalizedName == this._lastLoadedNormalizedName) return;

		this.isReadonly = true;
		let existingDisease = await diseases.get(this.normalizedName);
		if (existingDisease) {
			this._lastLoadedNormalizedName = this.normalizedName;
			this.name = existingDisease.name;
			this.description = existingDisease.description;
			this.removed = existingDisease.removed;

			// NOTE!!!
			// this is what we SHOULD be doing, but it's broken:
			// this.symptoms = existingDisease.symptoms.map(s => new Symptom({text: String(s)}));
			this.symptoms = [];
			existingDisease.symptoms.forEach(s => {
				_t.symptoms.push(new EditableSymptom({text: s}));
			});
		}
		this.isReadonly = false;
	};

	this.addSymptom = async function() {
		let symptomText = new String(this.newSymptom);
		if (symptomText) {
			this.symptoms.push(new EditableSymptom({text: symptomText}));
		}
		this.newSymptom = '';
	};

	this.__dom.name.onchange = async function() {
		_t.load();
	};

	this.__dom.newSymptom.onkeydown = async function(e) {
		e = new KeyCode(e || window.event);

		// maybe this conditional should live in KeyCode?
		if (e.code == 'Enter' || e.code == 'NumpadEnter') {
			_t.addSymptom();
			return false;
		}
	};

	this.addSymptomButton.onclick = async function() {
		_t.addSymptom(this);
		return false;
	};

	this.__dom.saveDiseaseButton.onclick = async function() {
		try {
			await diseases.put({
				normalizedName: _t.normalizedName,
				name: _t.name,
				description: _t.description,
				removed: _t.removed,
				symptoms: _t.symptoms
					.map(s => s.text)
					.filter(s => s.trim())
			});
			router.navigate("?disease/" + _t.normalizedName);
		} catch (e) {
			console.error(e);
			alert("Error saving the new disease! Try again later.");
		}
	};

	this.load();

});

export default AddDiseaseForm;
